export default __webpack_public_path__ + "static/media/clover-297753_1280.bbb00241.png";